import React from 'react';
import { motion } from 'framer-motion';
const audiences = [{
  emoji: '🛍️',
  label: 'Ecommerce'
}, {
  emoji: '📱',
  label: 'Marcas personales'
}, {
  emoji: '📚',
  label: 'Infoproductores'
}, {
  emoji: '🎨',
  label: 'Creadores de contenido'
}, {
  emoji: '💼',
  label: 'Freelancers'
}, {
  emoji: '🚀',
  label: 'Agencias'
}, {
  emoji: '📦',
  label: 'Negocios digitales'
}, {
  emoji: '📢',
  label: 'Emprendedores que venden en redes'
}];
export const Audiences = () => {
  return <section className="py-12 md:py-24 bg-brand-dark" data-id="element-15">
      <div className="container px-4 mx-auto max-w-7xl" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-10 md:mb-16 text-center" data-id="element-17">
          <h2 className="text-3xl font-bold md:text-4xl" data-id="element-18">
            Utilizado en todo tipo de{' '}
            <span className="text-gradient-gold" data-id="element-19">negocios digitales</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-4 lg:gap-6" data-id="element-20">
          {audiences.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex flex-col items-center p-4 md:p-6 text-center transition-colors border rounded-xl bg-brand-card border-white/5 hover:border-brand-gold/30" data-id="element-21">
              <span className="mb-3 text-4xl" data-id="element-22">{item.emoji}</span>
              <span className="font-medium text-gray-300" data-id="element-23">{item.label}</span>
            </motion.div>)}
        </div>
      </div>
    </section>;
};